window.BCB.scrollOffset = 60;
window.BCB.mq = 1;
window.BCB.nextTick = function (func) {
    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            func();
        });
    });
};
window.BCB.throttle = require('lodash.throttle');
require('./elements/mq');
require('./elements/map');
require('./elements/nav');
require('./elements/form');
require('./elements/form-honeypots');
require('./elements/smava-blocked');
require('./modules/download');
require('./modules/gm-jameda');
require('./modules/faqs');
require('./modules/section');
require('./modules/videoheader');
require('./modules/slider');
